import {lang, sessid, axiosConfig, eventEmitter} from '../../common/baseData';
import axios from 'axios'
import Cookies from 'js-cookie'

class Analytics {
  url = '/local/analytics.ajax.php'
  config = { headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } }
  beginCheckoutCookie = 'ga4_begin_checkout'

  selectItem (item_id, list_name = '', list_id = '') {
    let body = JSON.stringify({
      event: 'selectItem',
      event_data: {
        item_id: item_id,
        list_name: list_name,
        list_id: list_id,
      },
      lang: lang,
      sessid: sessid
    })

    return axios.post(this.url, body, this.config)
  }

  view_cart (totalPrice, items_params = {}) {
    // Measure when a product is added to a shopping cart

    //Добавляем в событие данные из цепочки переходов по товару
    items_params = this.enrichItemsArrayFromStorage(items_params);

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "view_cart",
      ecommerce: {
        currency: 'UAH',
        value: totalPrice,
        items: items_params
      }
    });
  }

  /**
   * Sends a 'view_promotion' event to the dataLayer with promotion data
   *
   * @param {Object} promotionData - The promotion data containing promotion info and items
   * @param {string} promotionData.promotion_id - The ID of the promotion
   * @param {string} promotionData.promotion_name - The name of the promotion
   * @param {Array} promotionData.items - Array of items in the promotion
   * @param {string} creative_name - Creative name for the promotion (optional)
   * @param {string} creative_slot - Creative slot for the promotion (optional)
   * @return {void}
   */
  view_promotion(promotionData, creative_name = '', creative_slot = '') {
    // Check if promotion data exists and has items
    if (!promotionData || !promotionData.items || !promotionData.items.length) {
      console.warn('No valid promotion data provided for view_promotion event');
      return;
    }

    // Clear previous ecommerce object and push new promotion event
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "view_promotion",
      ecommerce: {
        promotion_id: promotionData.promotion_id,
        promotion_name: promotionData.promotion_name,
        items: promotionData.items
      }
    });

    console.info('view_promotion event sent:', {
      promotion_id: promotionData.promotion_id,
      promotion_name: promotionData.promotion_name,
      items_count: promotionData.items.length
    });
  }

  /**
   * Обогащает параметры товара данными из localStorage ga_products.
   *
   * @param {string|number} item_id - ID товара для поиска в localStorage
   * @param {Object} item_params - Параметры товара, которые могут быть обогащены
   * @returns {Object} - Обогащенные параметры товара
   */
  enrichItemParamsFromStorage(item_id, item_params = {}) {
    try {
      const storedProducts = localStorage.getItem('ga_products');
      if (storedProducts) {
        const gaProducts = JSON.parse(storedProducts);

        // Проверяем, существует ли запись с таким item_id
        if (gaProducts[item_id]) {
          const storedProductData = gaProducts[item_id];

          // Объединяем данные из localStorage с переданными параметрами
          // Переданные параметры имеют приоритет
          return {
            ...storedProductData,  // Данные из localStorage
            ...item_params         // Переданные параметры (имеют приоритет)
          };
        }
      }

      // Если данных в localStorage нет, возвращаем исходные параметры
      return item_params;
    } catch (error) {
      console.error('Error enriching item params from localStorage:', error);
      return item_params; // В случае ошибки возвращаем исходные параметры
    }
  }

  /**
   * Обогащает параметры массива товаров данными из localStorage ga_products.
   *
   * @param {Array<Object>} items - Массив объектов товаров для обогащения
   * @returns {Array<Object>} - Массив обогащенных объектов товаров
   */
  enrichItemsArrayFromStorage(items) {
    if (!items || !Array.isArray(items) || items.length === 0) {
      return items;
    }

    try {
      // Получаем данные из localStorage один раз для всего массива
      const storedProducts = localStorage.getItem('ga_products');
      if (!storedProducts) {
        return items; // Если нет данных, возвращаем исходный массив
      }

      const gaProducts = JSON.parse(storedProducts);

      // Обрабатываем каждый элемент массива
      return items.map(item => {
        const item_id = item.item_id;

        // Если нет item_id или нет данных для этого товара, оставляем как есть
        if (!item_id || !gaProducts[item_id]) {
          return item;
        }

        // Объединяем данные
        return {
          ...gaProducts[item_id], // Данные из localStorage
          ...item                 // Данные из переданного объекта (приоритетные)
        };
      });
    } catch (error) {
      console.error('Error enriching items array from localStorage:', error);
      return items; // В случае ошибки возвращаем исходный массив
    }
  }

  viewItem (item_id, item_params = {}) {
    // Measure a view of product details. This example assumes the detail view occurs on pageload,

    //Добавляем в событие данные из цепочки переходов по товару
    item_params = this.enrichItemParamsFromStorage(item_id, item_params);

    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: "view_item",
      ecommerce: {
        items: [item_params]
      }
    });
  }

  viewItemList (item_ids, list_name = '', list_id = '') {
    return new Promise(resolve => {
      let body = JSON.stringify({
        event: 'viewItemList',
        event_data: {
          item_ids: item_ids,
          list_name: list_name,
          list_id: list_id,
        },
        lang: lang,
        sessid: sessid
      })

      axios.post(this.url, body, this.config)
        .then(response => {
          resolve(response.data)
        })
        .catch(reason => {
          console.log(reason)
          resolve()
        })
    })
  }

  /**
   * Tracks the action of adding an item to the shopping cart and sends relevant data to the data layer.
   *
   * @param {Object} params - The parameters related to the "add to cart" event.
   * @param {number} params.total_price - The total price of the items added to the cart.
   * @param {Object} params.item - The item being added to the cart, including its details (e.g., id, name, category).
   * @param {Array<Object>} params.items - Several items added at once (e.g. product with warranty), used instead of params.item.
   * @return {void} This method does not return a value.
   */
  add_to_cart(params) {
    //Добавляем в событие данные из цепочки переходов по товару
    const items = (params.items || [params.item])
      .map(item => this.enrichItemParamsFromStorage(item.item_id, item));

    // Measure when a product is added to a shopping cart
    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        currency: "UAH",
        value: params.total_price,
        items: items
      }
    });
  }

  /**
   * Tracks the removal of an item from the shopping cart and updates the analytics data layer.
   *
   * @param {Object} params - The parameters for removing an item from the cart.
   * @param {Object} params.item - The item being removed from the cart.
   * @param {number} params.total_price - The total price of the cart after the item is removed.
   * @return {void} This method does not return a value.
   */
  remove_from_cart(params) {
    // Measure when a product is added to a shopping cart
    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
      event: "remove_from_cart",
      ecommerce: {
        currency: "UAH",
        value: params.total_price,
        items: [params.item]
      }
    });
  }

  /**
   * Adds an item to the wishlist and updates the dataLayer with the event.
   *
   * @param {Object} params - The parameters for adding to the wishlist.
   * @param {Object} params.item - The item object to be added to the wishlist, containing relevant product details.
   * @return {void} This function does not return a value.
   */
  add_to_wishlist(params) {
    params.item.quantity = 1;
    // Measure when a product is added to a shopping cart
    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
      event: "add_to_wishlist",
      ecommerce: {
        items: [params.item]
      }
    });
  }

  /**
   * Передает в dataLayer данные корзины для GA4 begin_checkout на странице оформления.
   * Событие отправляет тег GTM по стандартному триггеру Window Loaded при checkout_first_view = true:
   * первое открытие оформления до закрытия браузера (сессионная cookie) или после оформленного заказа.
   * Данные в отдельном ключе begin_checkout_ecommerce, общий ecommerce
   * до Window Loaded перезаписывают UA события оформления (gtm-ee-event) при автозаполнении формы
   *
   * @param {Object} params - GA4 данные корзины
   * @param {number} params.total_price - Сумма корзины
   * @param {Array<Object>} params.items - Товары корзины
   * @return {void}
   */
  begin_checkout_data(params) {
    // ошибка аналитики не должна ломать страницу оформления
    try {
      if (!params || !Array.isArray(params.items) || params.items.length === 0) return;

      const firstView = Cookies.get(this.beginCheckoutCookie) !== '1';
      if (firstView) Cookies.set(this.beginCheckoutCookie, '1', { path: '/' });

      dataLayer.push({
        checkout_first_view: firstView,
        begin_checkout_ecommerce: {
          currency: "UAH",
          value: params.total_price,
          //Добавляем в событие данные из цепочки переходов по товару
          items: this.enrichItemsArrayFromStorage(params.items)
        }
      });
    } catch (error) {
      console.error('Error pushing begin_checkout data:', error);
    }
  }

  /**
   * Сброс признака begin_checkout после оформления заказа:
   * следующее открытие оформления снова отправит событие
   *
   * @return {void}
   */
  reset_begin_checkout() {
    Cookies.remove(this.beginCheckoutCookie, { path: '/' });
  }

  /**
   * Отправляет в dataLayer событие GA4 о заполнении данных доставки
   *
   * @param {Object} params Данные заказа, выбранной доставки и товаров
   */
  add_shipping_info(params) {
    params.items = this.enrichItemsArrayFromStorage(params.items);

    const ecommerce = {
      currency: "UAH",
      value: params.total_price,
      shipping_tier: params.shipping_tier,
      items: params.items
    };

    if (params.coupon) ecommerce.coupon = params.coupon;

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "add_shipping_info",
      // кастомное поле shipping_city добавляется параметром события в GTM
      shipping_city: params.shipping_city || '',
      ecommerce
    });
  }

  /**
   * Отправляет в dataLayer событие GA4 о заполнении данных оплаты
   *
   * @param {Object} params Данные заказа, выбранного способа оплаты и товаров
   */
  add_payment_info(params) {
    params.items = this.enrichItemsArrayFromStorage(params.items);

    const ecommerce = {
      currency: "UAH",
      value: params.total_price,
      payment_type: params.payment_type,
      items: params.items
    };

    if (params.coupon) ecommerce.coupon = params.coupon;

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "add_payment_info",
      ecommerce
    });
  }

  addToCart (item_id) {
    let body = JSON.stringify({
      event: 'addToCart',
      event_data: {
        item_id: item_id
      },
      lang: lang,
      sessid: sessid
    })

    axios.post(this.url, body, this.config)
      .then(response => {
        //console.dir(response)
      })
  }

  /**
   *
   * @param orderId
   * @returns {Promise<Object>}
   */
  purchase (orderId) {
    return new Promise((resolve) => {
      axios.post(this.url, JSON.stringify({
        event: 'orderPurchase',
        event_data: { order_id: orderId },
        lang: lang,
        sessid: sessid
      }), this.config)
        .then(response => {
          console.info(response)
          if (response.data !== null && !response.data.hasOwnProperty('error')) {
            window.dataLayer.push({ ecommerce: null })
            window.dataLayer.push({
              event: 'purchase',
              ecommerce: response.data
            })
          }
          resolve()
        })
        .catch(reason => {
          console.log(reason)
          resolve()
        })
    })
  }

  /**
   * Sends a 'select_item' event to the dataLayer with the provided ecommerce parameters.
   * Clears the previous ecommerce object before pushing the new event data.
   *
   * @param {Object} params - The parameters related to the selected item, structured as per the ecommerce specifications.
   * @return {void} - This method does not return any value.
   */
  select_item(params){
    this.updateGAProductsList(params);

    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
      event: "select_item",
      ecommerce: params
    });
  }

  /**
   * Updates or adds product information in localStorage based on provided params.
   *
   * @param {Object} params - Object containing product information
   * @param {number} params.ga_session_id - Google Analytics session ID
   * @param {string} params.item_list_id - List identifier
   * @param {string} params.item_list_name - List name
   * @param {Array} params.items - Array of product items
   * @return {void}
   */
  updateGAProductsList(params) {
    // Проверяем наличие необходимых данных
    if (!params || !params.items || !params.items.length) {
      console.warn('No valid items data provided for GA products update');
      return;
    }

    // Для каждого элемента в массиве items
    params.items.forEach(item => {
      const item_id = item.item_id;
      if (!item_id) {
        console.warn('Item without item_id found, skipping');
        return;
      }

      // Получаем текущие данные из localStorage или инициализируем пустой объект
      let gaProducts = {};
      try {
        const storedProducts = localStorage.getItem('ga_products');
        if (storedProducts) {
          gaProducts = JSON.parse(storedProducts);
        }
      } catch (error) {
        console.error('Error parsing ga_products from localStorage:', error);
      }

      // Проверяем существует ли запись с таким item_id
      if (gaProducts[item_id]) {
        // Обновляем существующую запись
        gaProducts[item_id].item_list_id = params.item_list_id;
        gaProducts[item_id].item_list_name = params.item_list_name;
      } else {
        // Создаем новую запись
        gaProducts[item_id] = {
          item_id: item_id,
          item_list_id: params.item_list_id,
          item_list_name: params.item_list_name,
        };
      }

      // Сохраняем обновленные данные в localStorage
      try {
        localStorage.setItem('ga_products', JSON.stringify(gaProducts));
        this.saveGAProducts(gaProducts);
      } catch (error) {
        console.error('Error saving ga_products to localStorage:', error);
      }
    });
  }

  /**
   * Sends Google Analytics products data to the server.
   *
   * @param {Array} gaProducts - The array of Google Analytics product data to be sent to the server.
   * @return {Promise} Returns a promise that resolves with the server response or rejects with an error if the request fails.
   */
  sendGAProductsToServer(gaProducts) {
    return axios.post('/local/api/saveGaProducts.php', {
      ga_products: gaProducts
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  /**
   * Saves the GA products to both browser's local storage and session storage,
   * and sends them to the server for further processing and saving in a PHP session.
   *
   * @param {Object[]} gaProducts - An array of GA product objects to be saved.
   * @return*/
  saveGAProducts(gaProducts) {
    try {
      // Сохраняем в локальные хранилища браузера
      const jsonData = JSON.stringify(gaProducts);
      localStorage.setItem('ga_products', jsonData);
      sessionStorage.setItem('ga_products', jsonData);

      // Отправляем на сервер для сохранения в PHP сессию
      this.sendGAProductsToServer(gaProducts);

      return true;
    } catch (error) {
      console.error('Error saving ga_products:', error);
      return false;
    }
  }

  /**
   * Removes a single product from ga_products in localStorage.
   *
   * @param {string|number} item_id - ID of the item to remove
   * @return {boolean} - True if item was successfully removed, false otherwise
   */
  removeGAProduct(item_id) {
    if (!item_id) {
      console.warn('No valid item_id provided for GA product removal');
      return false;
    }

    // Получаем текущие данные из localStorage
    let gaProducts = {};
    try {
      const storedProducts = localStorage.getItem('ga_products');
      if (storedProducts) {
        gaProducts = JSON.parse(storedProducts);
      } else {
        console.log('No ga_products found in localStorage, nothing to remove');
        return false;
      }
    } catch (error) {
      console.error('Error parsing ga_products from localStorage:', error);
      return false;
    }

    // Проверяем существует ли запись с таким item_id
    if (gaProducts[item_id]) {
      // Удаляем запись
      delete gaProducts[item_id];

      // Сохраняем обновленные данные в localStorage
      try {
        localStorage.setItem('ga_products', JSON.stringify(gaProducts));
        console.log(`Product with ID ${item_id} removed from ga_products`);
        return true;
      } catch (error) {
        console.error('Error saving ga_products to localStorage after removal:', error);
        return false;
      }
    } else {
      console.log(`Product with ID ${item_id} not found in ga_products`);
      return false;
    }
  }

  /**
   * Отправляет событие просмотра контента в Facebook
   *
   * @param {Object} params - Параметры для отправки в Facebook
   * @return {void}
   */
  facebookViewContentPost(params) {
    if (!params) {
      console.warn('Не удалось определить params для отправки в facebook');
      return;
    }

    axios.post('/local/api/facebook/viewContent', { params: params }, axiosConfig)
    .then(response => {
      if (response && response.hasOwnProperty('data')) {
        // отправка события смены состояния корзины
        if (response.data.hasOwnProperty('success') && response.data.success){
          //console.log(`Успешно отправлен запрос в Facebook для действия "viewContentAction":`, response);
        } else {
          //console.error(`Ошибка ответа от Facebook для действия "viewContentAction":`, response);
        }
      }
    })
    .catch(reason => {
      console.error(`Ошибка запроса к Facebook для действия "viewContentAction":`, reason);
    })
  }

  view_item_list(params){
    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
      event: "view_item_list",
      ecommerce: params
    });
  }

  /**
   * Отправляет событие PageView в Facebook
   *
   * @param {Object} params - Параметры для отправки в Facebook
   * @return {void}
   */
  facebookPageViewPost(params) {
    if (!params) {
      console.warn('Не удалось определить params для отправки в facebook');
      return;
    }

    axios.post('/local/api/facebook/pageView', params, axiosConfig)
    .then(response => {
      if (response && response.hasOwnProperty('data')) {
        if (response.data.hasOwnProperty('success') && response.data.success){
          //console.log(`Успешно отправлен запрос в Facebook для действия "pageView":`, response);
        }
      }
    })
    .catch(reason => {
      console.error(`Ошибка запроса к Facebook для действия "pageView":`, reason);
    })
  }
}

export default Analytics